<template lang="">
  <div class="all">
    <div v-if="language == 'en'" class="extendedRichtext">
      <h1>Terms of Use</h1>
      <div class="text introduction">
        <p>
          Due to ongoing technical innovations and changes of the relevant legal
          framework the following Terms of Use need to be changed and/or amended
          by us from time to time. We therefore ask the user to review these
          Terms of Use before each visit to this website and to take into
          account any changes and/or amendments.
        </p>
      </div>
      <div>
        <div class="text"><h2>Introduction</h2></div>
        <div class="text">
          <p>
            This website is brought to you by Henkel (China) Investment Co.,
            Ltd., Henkelstrasse 67, 40589 Düsseldorf, Germany. The information
            available on this website about Henkel (China) Investment Co., Ltd.
            (hereinafter referred to as "Henkel"), affiliated companies of
            Henkel and third parties has been put together with utmost care.
            However, we are unable to guarantee the completeness and correctness
            of the information. Henkel does not assume any liability for any
            mistakes in the contents of this website. Forward-looking statements
            made on this website have been given according to the best of our
            knowledge and belief. However, the results actually achieved by
            Henkel may differ greatly from these forward-looking statements,
            because they depend on a whole group of factors of a competitive and
            macroeconomic nature that are in some cases beyond the control of
            Henkel. Without prejudice to any legal obligations to amend
            forward-looking statements, Henkel has no intention of constantly
            updating all forward-looking statements contained in this website.
          </p>
        </div>
        <div class="text">
          <p>
            By accessing this site, you accept without restriction or
            reservation the following General Terms of Use of the Website that
            you can view or print out.
          </p>
        </div>
        <div class="text">
          <p>
            THIS WEBSITE AND THE INFORMATION CONTAINED HEREIN IS NOT INTENDED OR
            APPROVED FOR USE INSIDE THE UNITED STATES OF AMERICA OR U.S.
            CITIZENS OR RESIDENTS. SAID PERSONS ARE KINDLY ASKED TO CONTACT
            THEIR LOCAL HENKEL WEBSITE OR WEBSITES OF US- AFFILIATED COMPANIES
            OF HENKEL.
          </p>
        </div>
        <div class="text"><h2>General Terms of Use of the Website</h2></div>
        <div class="text"><h3>1. Copyright Law</h3></div>
        <div class="text">
          <p>
            The pages of our site (contents, structure) are protected by
            copyright. In particular, any reproductions, adaptations,
            translations, storage and processing in other media, including
            storage or processing by electronic means, enjoy copyright
            protection. Any exploitation in whole or in part thereof shall
            require the prior written consent of Henkel (China) Investment Co.,
            Ltd.. Any reproduction of information or data, in particular the use
            of texts or parts thereof or image materials (except for Henkel
            press photos) or any other exploitation or dissemination, requires
            Henkel's prior written consent. The rights of dissemination and
            reproduction are held by Henkel.
          </p>
        </div>
        <div class="text">
          <p>
            Henkel press photos may be used for editorial purposes only. Henkel
            press photos that are reproduced and/or electronically modified for
            editorial purposes must bear the copyright notice "© [Year] Henkel
            (China) Investment Co., Ltd.. All rights reserved". Reprinting is
            free of charge, however, we request a copy for our files.
          </p>
        </div>
        <div class="text">
          <p>
            © 2018 Henkel (China) Investment Co., Ltd., Düsseldorf. All rights
            reserved
          </p>
        </div>
        <div class="text"><h3>2. Trademarks</h3></div>
        <div class="text">
          <p>
            The Henkel Oval logo and all product names and/or product get-ups on
            these pages are registered trademarks of Henkel (China) Investment
            Co., Ltd., its subsidiaries, affiliates or licensors. Any
            unauthorized use or abuse of these trademarks is expressly
            prohibited and constitutes a violation of trademark law, copyright
            law, other intellectual property rights or unfair competition law.
          </p>
        </div>
        <div class="text"><h3>3. Disclaimer for Third Party Websites</h3></div>
        <div class="text">
          <p>
            a. The pages of this website contain links (i.e. "hyperlinks") to
            other websites that are operated by third parties and whose contents
            are not known to Henkel. Henkel merely facilitates access to such
            websites and assumes no responsibility whatsoever for their
            contents. Our links to third party websites are merely intended to
            make navigating easier for you. Statements shown on linked pages are
            not made our own. We rather explicitly dissociate from any and all
            contents of any and all third party pages linked on the pages of our
            website. In particular, we do not assume any liability for any
            breaches of statutory provisions or infringements of third party
            rights that occur on such pages.
          </p>
        </div>
        <div class="text">
          <p>
            b. For websites to which hyperlinks are provided from the Henkel
            website, the owners of these websites are solely responsible for the
            content of these pages as well as for any sale of the products
            offered thereon and for the handling of any orders relating to the
            same.
          </p>
        </div>
        <div class="text">
          <p>
            c. Henkel does not assume any liability for any infringement of any
            copyrights, trademarks or other intellectual property or personality
            rights that occurs on a page accessed by a hyperlink.
          </p>
        </div>
        <div class="text">
          <p>
            d. In the event of an order or any other legal declaration in
            respect of a transaction, a contract is made solely between the user
            and the owner of the respective website or offering party or person
            presented therein, under no circumstances, however, between Henkel
            and the user. Please note the general business conditions of the
            respective supplier on the hyperlinked website.
          </p>
        </div>
        <div class="text">
          <p>
            e. This disclaimer is valid for all links displayed on the
            henkel.com website and for any contents of websites to which the
            user is directed via such links.
          </p>
        </div>
        <div class="text"><h3>4. General Disclaimer</h3></div>
        <div class="text">
          <p>
            Any liability of Henkel for damages arising out of the use of this
            website – irrespective of the legal cause, including tort – is
            limited to damages that are caused by intent or gross negligence. To
            the extent that there be a mandatory liability of Henkel as a result
            of a breach of material contractual duties, the total amount of any
            claim for damages is limited to the foreseeable damages. This shall
            not affect Henkel's liability under applicable Product Liability law
            or under any warranties given. The aforesaid limitations of
            liability also do not apply in the event of harm to life, bodily
            injury or harm to health of a person.
          </p>
        </div>
        <div class="text">
          <p>
            Henkel employs great efforts to keep Henkel websites free from
            viruses, however, we are unable to guarantee any absence of viruses.
            For this reason, we recommend that care be taken to assure adequate
            protection against viruses (e.g. using virus scanners) before
            downloading documents and data.
          </p>
        </div>
        <div class="text">
          <p>
            Henkel does not warrant any freedom from faults or errors of the
            services offered on the Henkel website nor their availability.
          </p>
        </div>
        <div class="text"><h3>5. Forecasts and Declarations of Intent</h3></div>
        <div class="text">
          <p>
            Forward-looking statements on this Internet site have been made
            according to the best of our knowledge and belief. However, the
            results actually achieved by Henkel may differ greatly from these
            forward-looking statements, because they depend on a whole group of
            factors of a competitive and macroeconomic nature that are in some
            cases beyond the control of Henkel. Without prejudice to any legal
            obligations to amend forward-looking statements, Henkel has no
            intention of constantly updating all forward-looking statements
            contained in this website.
          </p>
        </div>
        <div class="text"><p></p></div>
        <div class="text"><h3>6. Henkel Products</h3></div>
        <div class="text">
          <p>
            The brands / products shown on this Internet website are examples of
            the brands / products available from companies of Henkel worldwide.
            Henkel does not warrant that a brands / product shown is also
            available in your country.
          </p>
        </div>
        <div class="text"><h3>Miscellaneous</h3></div>
        <div class="text">
          <p>
            These General Terms of Use are governed by and construed in
            accordance with the laws of the Federal Republic of Germany without
            regard to the UN Convention on Contracts for the International Sale
            of Goods the application of which Convention to these General Terms
            of Use is hereby expressly excluded. To the extent permitted by
            applicable law, legal venue for all disputes relating to this
            website lies with Düsseldorf, Germany. Should any provision of these
            General Terms of Use be or become invalid, this shall not affect the
            validity of the remaining provisions.
          </p>
        </div>
      </div>
    </div>
    <div v-if="language == 'cn'" class="extendedRichtext">
      <h1 data-v-10055961="">使用条款</h1>
      <div class="text introduction">
        <p data-v-10055961="">
          鉴于不断涌现的技术创新与法律体制变化，我们需要就以下使用条款不时地进行变更和/或修订。因此，我们要求使用者每次访问本网站之前务必审视此类使用条款并将所有变更和/或修订纳入考虑。
        </p>
      </div>
      <div data-v-10055961="">
        <div class="text"><h2 data-v-10055961="">简介</h2></div>
        <div class="text">
          <p data-v-10055961="">
            本网站由位于德国杜塞尔多夫汉高大街67号（邮编：40589）的德国汉高股份有限及两合公司（Henkel
            AG &amp;amp;
            Co.KGaA，以下简称“汉高公司”或“我公司”）制作。本网站有关汉高公司、其关联公司或第三方的信息都是我公司尽最大努力制作的；但是，我公司无法保证这些信息都是完整、正确及最新的。对本网站内容可能存在的任何错误或偏差，我公司在此声明将不承担任何直接或间接的法律责任。这里的汉高公司的关联公司应尤其包括汉高（中国）投资有限公司。
          </p>
        </div>
        <div class="text">
          <p data-v-10055961="">
            进入本网站时，您须毫无保留、无任何限制地接受下述使用条件。您可以进行浏览或打印。
          </p>
        </div>
        <div class="text">
          <p data-v-10055961="">
            本网站及所含信息不打算或不批准在美利坚合众国国内或供美国公民或居民使用。以上人群可访问当地汉高网站或汉高美国子公司网站。
          </p>
        </div>
        <div class="text"><h2 data-v-10055961="">网站的一般使用条款</h2></div>
        <div class="text"><h3 data-v-10055961="">1. 著作权</h3></div>
        <div class="text">
          <p data-v-10055961="">
            本网站（内容、结构）的所有网页受所适用的著作权法保护。这种受保护的著作权尤其包括但不限于：在其他媒体上的复制权、改编权、翻译权、存储权和处理权，包括使用电子方式的存储权和处理权。未经德国汉高股份有限及两合公司书面同意，任何复制和开发利用本网站全部或部分网页的行为均属禁止。对任何信息和数据的复制，尤其是使用原文、片段或图像资料（我公司用作新闻发布的照片除外）,或任何其他形式的开发或出版，皆须事先取得我公司的书面确认。出版权和复制权归我公司所有。
          </p>
        </div>
        <div class="text">
          <p data-v-10055961="">
            汉高新闻照片仅供发表社论使用。汉高新闻照片被重新复制和/或经过修改的电子版本，必须附带著作权标记“©
            Henkel (China) Investment Co., Ltd.【 年】，版权所有”字样。
            再版是免费的，但需抄送我公司备案。
          </p>
        </div>
        <div class="text">
          <p data-v-10055961="">
            © Henkel (China) Investment Co., Ltd. 2023年，版权所有。
          </p>
        </div>
        <div class="text"><h3 data-v-10055961="">2. 商标</h3></div>
        <div class="text">
          <p data-v-10055961="">
            本网站网页上出现的汉高标识和所有产品名称及/或产品包装均注册有汉高股份有限及两合公司，其子公司，附属企业和许可方商标。任何未授权使用或滥用此类商标均为明确禁止且构成违反《商标法》、《版权法》及其他知识产权或反不正当竞争法。
          </p>
        </div>
        <div class="text">
          <h3 data-v-10055961="">3. 对第三方网站不承担责任</h3>
        </div>
        <div class="text">
          <p data-v-10055961="">
            （1）本网站的网页上含有一些链接（如超链接），通过这些链接可以进入第三方经营的网站。我公司并没有必要完全了解这些网站的内容。我公司仅向您提供进入网站的便利，对这些网站的内容不承担任何直接或间接责任。我公司提供的进入第三方网站的链接旨在让您更容易地获知相关内容。这些被链接网站上的一些声明并非我公司所为。尤其是，我们对这些网站上违反国家法律法规或侵犯第三方权益的行为不承担任何直接或间接的法律责任。
          </p>
        </div>
        <div class="text">
          <p data-v-10055961="">
            （2）经由本网站的超链接而得以进入的网站的经营者将唯一性地对其网页上的内容、产品的销售以及产品订单的处理负责。
          </p>
        </div>
        <div class="text">
          <p data-v-10055961="">
            （3）我公司将不对任何发生在链接网站上的著作权、商标权或者隐私权侵权行为负责。
          </p>
        </div>
        <div class="text">
          <p data-v-10055961="">
            （4）如果一项交易的订单或者其他法律声明产生，那么由此而产生的合同将仅在用户和该网站的经营者或供应商之间成立，任何情况下皆不应导致在用户和我公司成立任何法律关系。请您注意超链接网站上载明的这些供应商的商业总则。
          </p>
        </div>
        <div class="text">
          <p data-v-10055961="">
            （5）
            本责任否认声明适用于汉高网站上所示所有链接及使用者通过此类链接所得的所有网站内容。
          </p>
        </div>
        <div class="text"><h3 data-v-10055961="">4. 除外责任</h3></div>
        <div class="text">
          <p data-v-10055961="">
            在法律所允许的最大范围之内，我公司将不对由于使用本网站所引起的任何损失承担责任。
          </p>
        </div>
        <div class="text">
          <p data-v-10055961="">
            我公司已采取一切必要措施使本网站不含计算机病毒，但是，我公司不能对此作出任何保证。因此，我公司向您提醒，在下载文件和数据之前，务必使用病毒扫描器或者采取其他病毒防护措施。
          </p>
        </div>
        <div class="text">
          <p data-v-10055961="">
            对本网站提供服务的差错或有效性，我公司不作出任何保证。
          </p>
        </div>
        <div class="text"><h3 data-v-10055961="">5. 对未来事项的预测</h3></div>
        <div class="text">
          <p data-v-10055961="">
            基于我公司管理层的合理预期，本网站含有一些面向将来的声明。当本网站中出现“期待”、“打算”、“相信”、“估计”、“期望”、“计划”和“方案”等字眼时，旨在标示这是一些关于未来事项的声明。这些声明反映了我公司在声明当日对未来事项的看法，因此是不确定的、有风险的。
          </p>
        </div>
        <div class="text">
          <p data-v-10055961="">
            许多因素可以导致实际结果与这些声明实质性不同，包括但不限于，总体经济和商业环境的变化，外汇汇率和利率的变化，公司成本的变化，诉讼和国际经营中的风险，竞争产品的引入，新产品或服务不被市场接受、购置和合并经营战略的转变以及环境保护、法律法规和知识产权事项等。我公司无法做到不断对部分或者全部声明进行更新，但会遵守相关法定义务及时更新有关声明。
          </p>
        </div>
        <div class="text"><h3 data-v-10055961="">6. 汉高产品</h3></div>
        <div class="text">
          <p data-v-10055961="">
            本网站所示产品均为汉高全球范围内所有公司的产品样本。汉高并未保证所示产品在您所在国家同样有售。
          </p>
        </div>
        <div class="text"><h3 data-v-10055961="">其他</h3></div>
        <div class="text">
          <p data-v-10055961="">
            本一般使用条款受制于德意志联邦共和国法律的规定并应根据德意志联邦共和国法律予以解释，但不适用《联合国国际货物销售合同公约》的有关规定。若适用法允许，与本网站相关的所有纠纷的管辖地均为德国杜塞尔多夫。本一般使用条款中若有任何条款为或成为无效，均不影响其余条款的效力。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { uiHelper } from "@/core/utils";

export default {
  name: "TermsOfUse",
  data: () => ({}),
  computed: {
    language() {
      return uiHelper.getLocalStorage("language");
    },
  },
};
</script>
<style lang="scss">
.all {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-top: 60px;
  font-size: 10px;
  color: #000;
  font-family: Segoe UI, Helvetica, sans-serif;
  position: relative;
  min-height: 100%;
  .standard-content .text > p:not(.h1-like-headline) {
    margin: 0 0 1.5em;
    max-width: 829px;
  }
  .extendedRichtext {
    width: 70%;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    line-height: 1.428571429;
    font-size: 10px;
    color: #000;
    font-family: Segoe UI, Helvetica, sans-serif;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    h1 {
      -webkit-text-size-adjust: 100%;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      box-sizing: border-box;
      font-family: inherit;
      line-height: 1.3;
      margin: 0;
      color: #e1000f;
      float: left;
      padding: 0 0 0.75em;
      width: 100%;
      word-wrap: break-word;
      max-width: 100%;
      font-weight: 300;
      font-size: 6rem;
    }
    h2 {
      -webkit-text-size-adjust: 100%;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      font-family: inherit;
      line-height: 1.3;
      color: inherit;
      font-weight: 400;
      max-width: 829px;
      font-size: 2.4rem;
      margin-top: 0;
      margin-bottom: 0.65em;
    }
    h3 {
      -webkit-text-size-adjust: 100%;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      font-family: inherit;
      line-height: 1.3;
      font-weight: 400;
      color: #e1000f;
      margin-top: 0;
      max-width: 829px;
      font-size: 2.4rem;
      margin-bottom: 0.5em;
    }
    p {
      -webkit-text-size-adjust: 100%;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      line-height: 1.428571429;
      color: #000;
      font-family: Segoe UI, Helvetica, sans-serif;
      box-sizing: border-box;
      padding: 0;
      font-size: 1.6rem;
      margin: 0 0 1.5em !important;
    }
    .fixed-footer {
      position: absolute;
      bottom: 0px;
      right: 0px;
      width: 100%;
      height: 80px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
